const STORAGE_KEY = "cf-referral";
const TRACKED_PARAMS = [
  "ref",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

/** Call once on app init. Captures referral/UTM params from the URL and stores them in sessionStorage. */
export function captureReferral(): void {
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const data: Record<string, string> = {};

  for (const key of TRACKED_PARAMS) {
    const value = params.get(key);
    if (value) data[key] = value;
  }

  if (Object.keys(data).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
}

/** Returns the captured referral data as a JSON string, or null if none was captured. */
export function getReferralSource(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

/**
 * Returns the member referral code from the captured `?ref=` param, if any.
 *
 * Distinct from `getReferralSource()`: that blob is marketing attribution,
 * while this is the code that earns a member commission. The server still
 * validates it — this only decides what to submit.
 */
export function getReferralCode(): string | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Record<string, string>;
    const code = parsed.ref?.trim().toUpperCase();
    return code ? code : null;
  } catch {
    return null;
  }
}
